import { useRef, useEffect } from 'react';

const useMounted = () => {
  const isMountRef = useRef(false);
  useEffect(() => {
    isMountRef.current = true;
  }, []);
  return isMountRef.current;
};

export default useMounted;
